export default __webpack_public_path__ + "static/media/O-119.95adcd11.png";